import React from 'react';

import classNames from 'classnames';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';

import { validationErrors } from './costAllocationApi';
import DialogModal from './DialogModal';

import Button from 'CommonComponents/Button';

/** Rename a report; titles are unique within the project, ignoring case. */
export default function RenameReportModal({ isOpen, onClose, report, reports, onSave }) {
    const takenTitles = reports.filter((other) => other.id !== report?.id).map((other) => other.title.trim().toLowerCase());

    const schema = Yup.object({
        title: Yup.string()
            .trim()
            .required($t('Enter a report title.'))
            .max(191)
            .test('unique', $t('A report with this title already exists.'), (value) => !takenTitles.includes((value || '').trim().toLowerCase())),
    });

    const submit = async (values, { setErrors, setSubmitting }) => {
        try {
            await onSave(values.title.trim());
        } catch (error) {
            const errors = validationErrors(error);
            errors && setErrors(errors);
            setSubmitting(false);
        }
    };

    return (
        <DialogModal id="cost-allocation-rename-report" isOpen={isOpen} onClose={onClose} title={$t('Rename report')} widthClass="tw-max-w-md">
            <Formik initialValues={{ title: report?.title ?? '' }} validationSchema={schema} validateOnChange={false} onSubmit={submit}>
                {({ errors, touched, isSubmitting }) => (
                    <Form className="modal__form-container tw-flex tw-flex-col tw-gap-y-1.5">
                        <label htmlFor="ca-rename-title" className="text-input__label !tw-normal-case">
                            {$t('Report title')}
                        </label>
                        <Field
                            id="ca-rename-title"
                            name="title"
                            autoFocus
                            maxLength={191}
                            className={classNames('text-input', { 'tw-border tw-border-red-500': touched.title && errors.title })}
                        />
                        {touched.title && errors.title && <div className="tw-text-sm tw-text-red-500">{errors.title}</div>}
                        <div className="modal__footer tw-justify-end tw-gap-x-1.5">
                            <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
                                {$t('Cancel')}
                            </Button>
                            <Button variant="primary" type="submit" disabled={isSubmitting} loading={isSubmitting}>
                                {$t('Save')}
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </DialogModal>
    );
}
